"use client";

import React from "react";
import { cn } from "utils";
import { QuickInsights } from "./QuickInsights";
import { CARD_CLASSES } from "./const";

interface QuickInsightsContentProps {
  featureCards: Array<{
    icon?: string;
    title?: string;
    description?: string;
    groupId?: string;
  }>;
  isLoading: boolean;
  onCardClick: (title: string) => void;
}

interface QuickInsightsSkeletonProps {
  bg: string;
  border: string;
}

/**
 * QuickInsights 骨架屏组件
 */
const QuickInsightsSkeleton: React.FC<QuickInsightsSkeletonProps> = () => {
  return (
    <div
      className={cn(
        "rounded-md overflow-hidden py-1 px-2 bg-background_white_overlay5",
      )}
    ></div>
  );
};

/**
 * QuickInsightsContent component displays a grid of quick insight cards
 */
export const QuickInsightsContent: React.FC<QuickInsightsContentProps> = ({
  featureCards,
  onCardClick,
  isLoading,
}) => {
  return (
    <div className="flex flex-nowrap gap-2">
      {isLoading &&
        Array.from({ length: 4 }).map((_, index) => (
          <QuickInsightsSkeleton
            key={`skeleton-${index}`}
            bg={CARD_CLASSES[index].bg}
            border={CARD_CLASSES[index].border}
          />
        ))}
      {!isLoading &&
        featureCards.length > 0 &&
        featureCards.map((card, index) => (
          <QuickInsights
            data-openreplay-label={card.title}
            key={index}
            bg={CARD_CLASSES[index].bg}
            border={CARD_CLASSES[index].border}
            color={CARD_CLASSES[index].color}
            onClick={onCardClick}
            icon={card.icon}
            title={card.title}
            description={card.description}
          />
        ))}
    </div>
  );
};
